/* Header nav badge for the Trial Room icon (nav/actions.html's trial_room()
 * macro) - same shape as webshop's own wishlist.js set_wishlist_count(),
 * just reading our own trial_room_count cookie (set by
 * raftor_webhq.catalog.trial_room's add/remove methods) instead of
 * wish_count, since Trial Room isn't a webshop feature webshop's own JS
 * knows about.
 *
 * window.rfhqUpdateTrialRoomBadge is called on page load here, and again by
 * grid.js / trial_room_page.js after any add/remove so the badge updates
 * live without a reload - exactly like wishlist's own animate-on-change
 * behaviour.
 */

(function () {
	'use strict';

	function updateTrialRoomBadge(animate) {
		var count = frappe.get_cookie('trial_room_count');
		if (frappe.session.user === 'Guest') count = 0;

		var icon = document.querySelector('.trial-room-icon');
		if (!icon) return; // feature flag off - macro never rendered it

		var badge = icon.querySelector('#trial-room-count');

		if (count && parseInt(count, 10) > 0) {
			document.querySelectorAll('.trial-room').forEach(function (el) {
				el.classList.remove('hidden');
			});
			icon.style.display = 'inline';
			if (badge) {
				badge.innerHTML = count;
				if (animate) {
					icon.classList.add('cart-animate');
					setTimeout(function () {
						icon.classList.remove('cart-animate');
					}, 500);
				}
			}
		} else {
			icon.style.display = 'none';
			// Emptied, not removed - wishlist.js removes its own badge
			// permanently since it always follows a full page reload after
			// an add/remove. Ours doesn't (grid.js's toggle updates the
			// badge live, no reload), so the element has to survive an
			// empty count to be refillable when the count goes positive
			// again in the same page view.
			if (badge) badge.innerHTML = '';
		}
	}

	window.rfhqUpdateTrialRoomBadge = updateTrialRoomBadge;

	frappe.ready(function () {
		updateTrialRoomBadge(false);
	});
})();
